<template>
  <div class="main">
    <Headbar fcstyle='black'></Headbar>
    <div class="mainbox">
      <!-- <div class="itembox">
        <div class="itemicon iconfont icon-yiwancheng"></div>
        <h2 class="">订单审核系统（<span>3</span>）</h2>
      </div>
      <div class="itembox">
        <div class="itemicon iconfont icon-icon-authorize"></div>
        <h2 class="">认证审核系统（<span>3</span>）</h2>
      </div>
      <div class="itembox">
        <div class="itemicon iconfont icon-icon-test"></div>
        <h2 class="">授信审核系统（<span>3</span>）</h2>
      </div> -->
      <router-link tag="div" to="/bankacceptance" class="itembox">
        <div class="itemicon iconfont icon-huobipiaoju"></div><!--icon-icon-business-->
        <h2 class="">电票审核系统</h2>
      </router-link>

      <router-link to="/businessticket" >
        <div class="itembox">
          <div class="itemicon iconfont icon-zhuye"></div>
          <h2 class="">商票助手系统</h2>
        </div>
      </router-link>
      
      <router-link to="/OrderHall" >
        <div class="itembox">
          <div class="itemicon iconfont icon-zhuye"></div>
          <h2 class="">小票直通车</h2>
        </div>
      </router-link>

      <router-link tag="div" to="/partner" class="itembox">
        <div class="itemicon iconfont icon-pingtaishouquan"></div>
        <h2 class="">合作机构管理维护</h2>
      </router-link>

      <div class="itembox">
        <div class="itemicon iconfont icon-duoceng"></div>
        <h2 class="">核心企业管理与维护</h2>
      </div>
      <div class="itembox">
        <div class="itemicon iconfont icon-yun"></div>
        <h2 class="">订单监控中心</h2>
      </div>
      <div class="itembox">
        <div class="itemicon iconfont icon-zhuye"></div>
        <h2 class="">账户中心</h2>
      </div>
      <!-- <div class="itembox">
        <div class="left" @click="leftClick">
          <img class="searchIcon" src="../assets/search.png">
          <div class="text1">{{this.tableData.examine}}个待审核</div>
          <div class="text2">订单发布审核</div>
       </div>
       <div class="itembox">
         <div class="right" @click="rightClick">
          <img class="lightIcon" src="../assets/light.png" >
          <div class="text1">{{this.tableData.error}}个待处理</div>
          <div class="text2">异常订单处理</div>
       </div> 
       </div>
      </div> -->
      <!-- <div class='showBox'>
       <div class="left" @click="leftClick">
         <img class="searchIcon" src="../assets/search.png">
         <div class="text1">{{this.tableData.examine}}个待审核</div>
         <div class="text2">订单发布审核</div>
       </div>
       <div class="right" @click="rightClick">
         <img class="lightIcon" src="../assets/light.png" >
         <div class="text1">{{this.tableData.error}}个待处理</div>
         <div class="text2">异常订单处理</div>
       </div> 
      </div> -->
    </div>
  </div>
</template>
<script>
  import Headbar from '@/components/headbar'
  export default {
      components: {
      Headbar
    },
    data () {
      return {
        tableData:[],
      }
    },
    mounted(){
        this.handleAjax()
    },
    methods:{
        handleAjax(){
            this.ajax.post('/bill/billstatistic',{bizContent:{}})
                .then(
                    result=>{
                        if(result.data.status=='0000'){
                            let add = result.data.data
                            this.tableData=add
                            // this.total=result.data.total
                            // if(this.radio2=='0'){
                            //     if(this.tableData.length==0){
                            //         this.showCon=false
                            //         //下面是修改后的代码，为了让表格显示出来
                            //         // this.showCon=true
                            //     }else{
                            //         this.showCon=true
                            //     }
                            // }
                            // this.loading=false
                        }else{
                            }
                        }
                )
        },

        handleRowClick(val){
            this.$router.push({
                name:'OrderDetail',
                query:{
                    // oid:val.orderId,
                    oId: val,
                    wendang: '背书超时订单-首次超时-详情',

                }
            })
        },
        leftClick(){
          this.$router.push({
                name:'WaitConfirm',
                query:{
                    // oid:val.orderId,
                    // oId: val,
                    // wendang: '背书超时订单-首次超时-详情',
                    sideNameId:'a',
                }
            })
        },
        rightClick(){
          this.$router.push({
                name:'FirstOvertime',
                query:{
                    // oid:val.orderId,
                    // oId: val,
                    // wendang: '背书超时订单-首次超时-详情',
                    sideNameId:'b',
                }
            })
        },
    }
  }

</script>

<style>
body{background-color: #F6F7FB;}
.mainbox{
  margin:7% 2%;
  background: #fff;
  min-height:660px;
  display: table;
  border-radius: 4px
}
.itembox{
  float: left;
  margin:3% 7%;
  width:320px;
  height:260px;
  background:rgba(255,255,255,1);
  box-shadow:0px 3px 15px rgba(0,0,0,0.08);
  border-radius:8px;
  cursor: pointer;
}
.itemicon{
  width:100px;
  height:100px;
  background: #57A2FB;
  margin:40px auto;
  line-height:100px;
  text-align: center;
  color: #fff;
  font-size: 58px;
  text-shadow: 1px 1px 2px rgb(24, 99, 190);
  -webkit-transition: font-size 0.1s linear;
  -moz-transition: font-size 0.1s linear;
  transition: font-size 0.1s linear;
}
.itembox:hover .itemicon{
  text-shadow: 1px 1px 2px rgba(24, 99, 190,.4);
  font-size:68px;
  -webkit-transition: font-size 0.1s linear;
  -moz-transition: font-size 0.1s linear;
  transition: font-size 0.1s linear;
}
.itembox h2{
  text-align: center;
  font-size:20px;
  font-weight: 400;
  color: #212121
}
.itembox h2 span{
  color:#D74147;
}

.showBox{
    padding-top: 60px;
    padding-left: 130px;
    display: flex;
    padding-bottom: 20px;
}

.left{
  width:320px;
  height:300px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 15px 0px rgba(0,0,0,0.11);
  border-radius:10px;
  margin-right: 260px;
  text-align: center;
}

.text1{
  height:40px;
  font-size:28px;
  font-family:PingFangSC-Medium,PingFang SC;
  font-weight:500;
  color:rgba(59,66,80,1);
  line-height:40px;
}

.text2{
  height:28px;
  font-size:20px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(102,102,102,1);
  line-height:28px;
}

.searchIcon{
  width: 90px;
  height: 80px;
  margin-top: 60px;
  margin-bottom: 45px;
}


.right{
  width:320px;
  height:300px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 15px 0px rgba(0,0,0,0.11);
  border-radius:10px;
  text-align: center;
}

.lightIcon{
  width: 87px;
  height: 80px;
  margin-top: 60px;
  margin-bottom: 45px;
}
</style>



// WEBPACK FOOTER //
// src/main/main.vue